window.getWishlist = function () {
  try {
    return JSON.parse(localStorage.getItem('wishlist') || '[]');
  } catch (e) {
    return [];
  }
};

window.saveWishlist = function (wishlist) {
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
};

window.updateWishlistCount = function () {
  const wishlist = window.getWishlist();
  document.querySelectorAll('.wishlist-count').forEach((el) => {
    el.textContent = wishlist.length;
    el.style.display = wishlist.length > 0 ? 'inline-flex' : 'none';
  });
};

window.updateWishlistButtons = function () {
  const wishlist = window.getWishlist();
  const ids = wishlist.map((item) => Number(item.id));
  document.querySelectorAll('.card-wishlist-btn, .wishlist-btn').forEach((btn) => {
    btn.classList.toggle('active', ids.includes(Number(btn.dataset.productId)));
  });
};

window.toggleWishlist = function (event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const btn = event.currentTarget;
  const productId = Number(btn.dataset.productId);

  const productData = {
    id: productId,
    title: btn.dataset.title || '',
    image: btn.dataset.image || '',
    url: btn.dataset.url || '',
    price: btn.dataset.price || '',
    comparePrice: btn.dataset.comparePrice || '',
  };

  let wishlist = window.getWishlist();
  const index = wishlist.findIndex((item) => Number(item.id) === productId);

  if (index === -1) {
    wishlist.push(productData);
  } else {
    wishlist.splice(index, 1);
  }

  window.saveWishlist(wishlist);
  window.updateWishlistButtons();
  window.updateWishlistCount();

  btn.style.transform = 'scale(1.3)';
  setTimeout(() => { btn.style.transform = 'scale(1)'; }, 200);
};

function initWishlist() {
  window.updateWishlistCount();
  window.updateWishlistButtons();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlist);
} else {
  initWishlist();
}

window.addEventListener('pageshow', initWishlist);

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.card-wishlist-btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const productId = Number(btn.dataset.productId);
  const productData = {
    id: productId,
    title: btn.dataset.title || '',
    image: btn.dataset.image || '',
    url: btn.dataset.url || '',
    price: btn.dataset.price || '',
    comparePrice: btn.dataset.comparePrice || '',
  };

  let wishlist = window.getWishlist();
  const index = wishlist.findIndex((item) => Number(item.id) === productId);

  if (index === -1) {
    wishlist.push(productData);
  } else {
    wishlist.splice(index, 1);
  }

  window.saveWishlist(wishlist);
  window.updateWishlistButtons();
  window.updateWishlistCount();

  btn.style.transform = 'scale(1.3)';
  setTimeout(() => { btn.style.transform = 'scale(1)'; }, 200);
}, true);